<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="1000" :key="listKey" sort-icon-left head-variant="light"
                        class="sa-b-table">
                        <template #cell(index)="riga">
                            {{ riga.index + 1 }}
                        </template>
                        <template #cell(importo)="item">
                            <span> {{ item.item.importo + "€" }}</span>
                        </template>
                        <template #cell(quotaAsl)="item">
                            <span> {{ item.item.quotaAsl + "€" }}</span>
                        </template>
                        <template #cell(quotaComune)="item">
                            <span> {{ item.item.quotaComune + "€" }}</span>
                        </template>
                        <template #cell(quotaUtente)="item">
                            <span> {{ item.item.quotaUtente + "€" }}</span>
                        </template>
                        <template #cell(percentualeAsl)="item">
                            <span> {{ item.item.percentualeAsl + "%" }}</span>
                        </template>
                        <template v-slot:cell(eventi)>
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Aggiorna Tariffa"
                                    variant="outline-secondary" @click="onClickAggiornaTariffa(item)">
                                    <font-awesome-icon icon="donate"> </font-awesome-icon>
                                </b-button>
                                <!-- <b-button size="sm" v-b-tooltip.hover title="Visualizza Prestazione"
                                    variant="outline-secondary" @click="onClickView(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>
                                class="mr-1 no-text" 
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Prestazione"
                                    variant="outline-success" @click="onClickEdit(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Prestazione"
                                    variant="outline-danger" @click="onClickDelete(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button> -->
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            rows: 0,
            pathResource: "/rsatipoprestazioni",
            listKey: 0,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: false,
                },
                {
                    label: "Cod. Prestazione",
                    key: "codicePrestazione",
                    sortable: false,
                },
                {
                    label: "Regime",
                    key: "regime",
                    sortable: false,
                },
                {
                    label: "Importo",
                    key: "importo",
                    sortable: false,
                },
                {
                    label: "Quota ASL(%)",
                    key: "percentualeAsl",
                    sortable: false,
                },
                {
                    label: "Quota ASL(€)",
                    key: "quotaAsl",
                    sortable: false,
                },
                {
                    label: "Note",
                    key: "note",
                },
                {
                    class: "sa-table-column-action-double",
                    key: "eventi",
                    label: "",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            let filter = {};
            if (sessionStorage["filtroTariffaImpegnativa"]) {
                filter = JSON.parse(sessionStorage["filtroTariffaImpegnativa"]);
            } else {
                filter = { dataRiferimento: new Date().getTime() }
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, filter, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
    },
};
</script>
